import { render, staticRenderFns } from "./budgetCompare.vue?vue&type=template&id=deb7ec64"
import script from "./budgetCompare.vue?vue&type=script&lang=js"
export * from "./budgetCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deb7ec64')) {
      api.createRecord('deb7ec64', component.options)
    } else {
      api.reload('deb7ec64', component.options)
    }
    module.hot.accept("./budgetCompare.vue?vue&type=template&id=deb7ec64", function () {
      api.rerender('deb7ec64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetCompare.vue"
export default component.exports